<template>
    <TransitionGroup name="notify" tag="div" class='notifyArea'>
    <div v-for="item in $store.state.notifyList"
        :key="item"
        :class="[ 'notifyItem', item.class]"
    >
        <div class='notifyText' v-html="item.notifyText"></div>
        <span
            class='delNotifyBtn'
            @click="delNotify(item.id)"
            ><img :src="define.pathToGraphics + '/delete4_14px.png' " alt=''
        /></span>
    </div>
    </TransitionGroup>
</template>

<script>
import { define } from '@/data/globals.js'
import useNotify from '@/hooks/useNotify'

export default {
  setup() {
    const { delNotify } = useNotify()

    return { define, delNotify }
  }
}
</script>

<style>

.notifyArea {
    z-index: 101;
    position: fixed;

    max-width: 360px;
    width: 100%;

    left: 0; 
    right: 0; 
    bottom: 40px;
    margin-left: auto;
    margin-right: auto;
}

.notifyItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    min-height: 64px;

    padding: 0px 0;
    margin-bottom: 10px;

    box-shadow: 2px 2px 10px #7a7a7a;
    border-radius: 10px;
    font-family: var(--fontSet3);
}

.notifyItem div {
    margin: 12px 15px;
    align-self: center;
}

.delNotifyBtn {
    background: #ffffff00;
    border: 0px;
    border: 2px solid #ffffff00;
    border-radius: 8px;
    margin: 4px;
    padding: 4px;

}

.delNotifyBtn:hover {
    cursor: pointer;
    background: #ffffff3a;
}

.delNotifyBtn img {
    display: block;
}



.notifyBlue {
    border: 0px;
    background: linear-gradient( 160deg, #33beff, #008fd1) no-repeat;
    color: #ffffff;
    text-shadow: 0px 0px 20px #0084c2;
}
.notifyOrange {
    border: 0px;
    background: linear-gradient( 160deg, #fca504, #da7400) no-repeat;
    color: #ffffff;
    text-shadow: 0px 0px 20px #8d4b00;
}
.notifyGreen {
    border: 0px;
    background: linear-gradient( 160deg, #00e226, #28a745) no-repeat;
    color: #ffffff;
    text-shadow: 0px 0px 20px #00a326;
}
.notifyRed {
    border: 0px;
    background: linear-gradient( 160deg, #ff4949, #d40000) no-repeat;
    color: #ffffff;
    text-shadow: 0px 0px 20px #be0000;
}

.notifyWelcome {
    border-top: 0px solid #28a745;
    background: linear-gradient( 120deg, #0045a0, #0077ff, #00a2ff, #01fb71) no-repeat;
    color: white;
}

.notifyWelcome div {
    margin: 14px;
}

.nowrap {
    white-space: nowrap;
}

.nowrap img {
    vertical-align: middle;
    margin-left: 2px;
    margin-right: 2px;
    margin-bottom: 0px;
}

.mail {
    color: #ffffff;
    text-decoration: underline;
}

.mail:hover {
    text-decoration: none;
}


.notify-enter-active { transition: all 1.6s ease; }
.notify-leave-active { transition: all 3s ease; }
.notify-enter-from {
    transform: translateY(-120px);
    opacity: 0;
}
.notify-leave-to {
    opacity: 0;
}


</style>